import web from '@/web';
import Location from '@/models/Location.ts';
import CheckoutOption from '@/models/CheckoutOption.ts';

let mutations = {
  addCheckoutOption(state, newOption) {
    var index = state.checkoutOptions.findIndex((option) => option.id === newOption.id);

    if (index === -1) {
      state.checkoutOptions.push(newOption);
    } else {
      state.checkoutOptions[index] = newOption;
    }
  },
  removeCheckoutOption(state, id) {
    const index = state.checkoutOptions.findIndex((option) => option.id === id);
    if (index !== -1) {
      state.checkoutOptions.splice(index, 1);
    }
  }
};

let actions = {
  async loadCheckoutOptions({ state }) {
    state.lastLoaded = new Date();

    const response = await web.getCheckoutOptions();

    console.log('Checkout options: ', response.data);

    state.checkoutOptions = response.data.checkout_options;
  },
};

const founder = {
  state: {
    checkoutOptions: [],
  },
  actions,
  mutations,
  getters: {
  }
};
export default founder;
